import { toast } from "react-toastify";
const initialState = {
  loading: false,
  error: null,
  list: [],
  info: null,
};
export default function transport(state = initialState, action) {
  let { type, data } = action;
  switch (type) {
    case "transport/list":
      return { ...state, loading: false, list: data, error: null };
    case "transport/info":
      return { ...state, loading: false, list: null, info: data, error: null };
    case "transport/update":
      return { ...state, loading: false, error: null };
    case "transport/add":
      return { ...state, loading: false, error: null };
    case "transport/setTransport":
      toast.success("روش ارسال با موفقیت تغییر یافت!");
      return { ...state, loading: false, error: null };
    case "transport/delete":
      return { ...state, loading: false, error: null };
    case "transport/loading":
      return { ...state, loading: true };
    case "transport/error":
      toast.error(data.message);
      return { ...state, loading: false, error: data.message };
    default:
      return state;
  }
}
